export default __webpack_public_path__ + "static/media/D_NewList_grid.6be17265.png";